/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Footer_ContactInputs */

const en_footer_contact = /** @type {(inputs: Footer_ContactInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contact`)
};

const lv_footer_contact = /** @type {(inputs: Footer_ContactInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kontakti`)
};

/**
* | output |
* | --- |
* | "Contact" |
*
* @param {Footer_ContactInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const footer_contact = /** @type {((inputs?: Footer_ContactInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Footer_ContactInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_footer_contact(inputs)
	return en_footer_contact(inputs)
});